document.addEventListener('DOMContentLoaded', function () {
    // 1. Obsługa buttonów "jobs__button--details"
    document.querySelectorAll('.jobs__button--details').forEach(function (button) {
        button.addEventListener('click', function () {
            const panelId = button.getAttribute('data-panel-id');
            const targetPanel = document.querySelector(`.job-panels__panel[data-panel-id="${panelId}"]`);
            const bgForSidePanels = document.querySelector('.bg-for-side-panels');
            
            if (targetPanel) {
                targetPanel.classList.add('job-panels__panel--active');
            }
            
            if (bgForSidePanels) {
                bgForSidePanels.classList.add('bg-for-side-panels--active');
            }
        });
    });

    // 2. Obsługa buttonów "job-panels__close"
    document.querySelectorAll('.job-panels__close').forEach(function (button) {
        button.addEventListener('click', function () {
            const parentPanel = button.closest('.job-panels__panel');
            const bgForSidePanels = document.querySelector('.bg-for-side-panels');
            
            if (parentPanel) {
                parentPanel.classList.remove('job-panels__panel--active');
            }
            
            if (bgForSidePanels) {
                bgForSidePanels.classList.remove('bg-for-side-panels--active');
            }
        });
    });

    // 3. Obsługa buttonów "job-panels__button"
    document.querySelectorAll('.job-panels__button').forEach(function (button) {
        button.addEventListener('click', function () {
            const jobTitle = button.getAttribute('data-job-title');
            const targetPanelForm = document.querySelector('.job-panels__panel--form');
            const jobPositionSpan = targetPanelForm.querySelector('.job-panels__position');
            const inquiryInput = document.querySelector('.inquiry-form__input--position');
            const parentPanel = button.closest('.job-panels__panel');
            
            if (jobPositionSpan) {
                jobPositionSpan.textContent = `(${jobTitle})`;
            }
            
            if (inquiryInput) {
                inquiryInput.value = jobTitle;
            }
            
            if (parentPanel) {
                parentPanel.classList.remove('job-panels__panel--active');
            }
            
            if (targetPanelForm) {
                targetPanelForm.classList.add('job-panels__panel--active');
            }
        });
    });

    // 4. Obsługa buttonów "jobs__button--apply"
    document.querySelectorAll('.jobs__button--apply').forEach(function (button) {
        button.addEventListener('click', function () {
            const jobTitle = button.getAttribute('data-job-title');
            const targetPanelForm = document.querySelector('.job-panels__panel--form');
            const jobPositionSpan = targetPanelForm.querySelector('.job-panels__position');
            const inquiryInput = document.querySelector('.inquiry-form__input--position');
            const bgForSidePanels = document.querySelector('.bg-for-side-panels');
            
            if (jobPositionSpan) {
                jobPositionSpan.textContent = `(${jobTitle})`;
            }
            
            if (inquiryInput) {
                inquiryInput.value = jobTitle;
            }
            
            if (bgForSidePanels) {
                bgForSidePanels.classList.add('bg-for-side-panels--active');
            }
            
            if (targetPanelForm) {
                targetPanelForm.classList.add('job-panels__panel--active');
            }
        });
    });
});